import { css } from '@emotion/core';
import theme from '../../current-theme';
import allHomesFonts from '../../themes/allhomes/globals/fonts';
import creFonts from '../../themes/cre/globals/fonts';
import domainFonts from '../../themes/domain/globals/fonts';
import priceFinderFonts from '../../themes/pricefinder/globals/fonts';
import rtaFonts from '../../themes/rta/globals/fonts';
var fontsIcons = {
  name: "1aumeve",
  styles: "@font-face{font-family:'Domain';src:url('https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-brary/static/fonts/domain-icons/Domain_v2.eot');src:url('https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-brary/static/fonts/domain-icons/Domain_v2.eot?#iefix') format('embedded-opentype'),url('https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-brary/static/fonts/domain-icons/Domain_v2.ttf') format('truetype'),url('https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-brary/static/fonts/domain-icons/Domain_v2.woff') format('woff'),url('https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-brary/static/fonts/domain-icons/Domain_v2.svg') format('svg');font-weight:normal;font-style:normal;}"
};
var themeFonts = {
  allhomes: allHomesFonts,
  cre: creFonts,
  domain: domainFonts,
  pricefinder: priceFinderFonts,
  rta: rtaFonts
};
var fontFace = /*#__PURE__*/css(fontsIcons, ";", themeFonts[theme]);
export default fontFace;